import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { AppStoreRedirectRoutes } from "./AppStoreRedirectRoutesNew";
import { AppStoreRedirectSite } from "./AppStoreRedirectSiteNew";
import { AppStoreRedirectStore } from "./AppStoreRedirectStoreNew";

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// This is the App Store Redirect Container running in PROD /georgeapp-campaign
// It is using the NEW App Store Redirect Store for the URL handling
//
// TODO: This can be deleted and the AppStoreRedirectContainer can be used instead @Bleron 30.04.2026 needs to give this free
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class AppStoreRedirectContainerCampaign extends React.Component<IProps> {
    store: AppStoreRedirectStore;

    constructor(props: IProps) {
        super(props);
        this.store = new AppStoreRedirectStore();
    }

    async componentDidMount() {
        pushRoute(AppStoreRedirectRoutes.CAMPAIGN);
        try {
            georgeWebHeaderStore.configure({
                title: ui.__("appStoreRedirect.document.title"),
            });
        } catch (error) {
            debug.log("### AppStoreRedirectContainerCampaign.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("appStoreRedirect.document.title");
        return (
            <div>
                <Route exact path={AppStoreRedirectRoutes.CAMPAIGN} component={this.withStore(AppStoreRedirectSite)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/appStoreRedirect/AppStoreRedirectContainerCampaign.tsx